import Popup from './popup.js';

$(document).ready(function($) {

  $('[data-btn-subscription-footer]').on('click', function(e) {
    e.preventDefault();

    let nameForm = 'subscriptionsNews', subscriptionsNewsForm = $('[data-popup-id="' + nameForm + '"]');

    if (subscriptionsNewsForm.length) {
      var emailSubscriptionFooter = $('[data-input-subscription-footer]'), valInputSubscriptionFooter = emailSubscriptionFooter.val(), emailSubscriptionsNewsForm = subscriptionsNewsForm.find('[data-email-subscriptions-news-form]');

      if ((valInputSubscriptionFooter != '') && emailSubscriptionsNewsForm.length) {
        emailSubscriptionsNewsForm.val(valInputSubscriptionFooter);
      }

      Popup.open(nameForm);
    }
  });

  let formSubscriptionsNews = $('[data-form-subscriptions-news]');
  if (formSubscriptionsNews.length) {
    formSubscriptionsNews.validate();

    formSubscriptionsNews.on('submit', function(event) {
      event.preventDefault();
      var form = $(this);

      if (form.valid()) {
        var msg = form.serialize();
        $.ajax({
          type     : 'POST',
          url      : '/'+window.langId+'/ajax/news-subscription.php',
          data     : msg,
          dataType : 'json',
          success  : function(data) {
            let messageContainer = $('[data-form-subscriptions-message]');
            if(messageContainer.length){
              messageContainer.html(data.message);
              if (data.success) {
                //formSubscriptionsNews.hide();
                messageContainer.css('color', 'green');
              } else {
                messageContainer.css('color', 'red');
              }
            }
            if (data.success) {
              setTimeout(function() {
                form.closest('[data-popup-id]').find('[data-popup-close]').click();
              }, 3000);
            }
          }
        });
      }
    });

    // Если не дано согласие на обработку персональных данных и не выбран хотя бы один
    // вариант подписки - блокируем кнопку отправки формы
    $('body').on('change', '[data-checkbox-subscr-news]', function(){
      var groupCheckbox = $('[data-group-checkbox-subscr-news]'),
          btnSubmit = $('[data-btn-submit-subscr-news]'),
          countCheck = 0;

      $('[data-group-checkbox-subscr-news]').each(function( index ) {
        if($(this).find('[data-checkbox-subscr-news]:checked').length){
          countCheck++;
        }
      });

      if(countCheck >= groupCheckbox.length) {
        btnSubmit.prop('disabled',false);
      }else{
        btnSubmit.prop('disabled',true);
      }
    });
  }

});


// WEBPACK FOOTER //
// ./components/news-subscription.js